(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2X0P9", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $2261bb1b144d0ab0$export$6503ec6e8aabbaf; }, function (v) { return $2261bb1b144d0ab0$export$6503ec6e8aabbaf = v; });
var $2261bb1b144d0ab0$export$6503ec6e8aabbaf;
var $2261bb1b144d0ab0$export$f7ad0328861e2f03;
"use strict";
var $2261bb1b144d0ab0$var$mapping = new Map();
function $2261bb1b144d0ab0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$2261bb1b144d0ab0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $2261bb1b144d0ab0$var$resolve(id) {
    var resolved = $2261bb1b144d0ab0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$2261bb1b144d0ab0$export$6503ec6e8aabbaf = $2261bb1b144d0ab0$var$register;
$2261bb1b144d0ab0$export$f7ad0328861e2f03 = $2261bb1b144d0ab0$var$resolve;

});

parcelRegister("eeZWf", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $a5e26b3134a5b8f0$export$bdfd709ae4826697; }, function (v) { return $a5e26b3134a5b8f0$export$bdfd709ae4826697 = v; });
var $a5e26b3134a5b8f0$export$bdfd709ae4826697;
var $a5e26b3134a5b8f0$export$c9e73fbda7da57b6;
var $a5e26b3134a5b8f0$export$5a759dc7a1cfb72a;
"use strict";
var $a5e26b3134a5b8f0$var$bundleURL = {};
function $a5e26b3134a5b8f0$var$getBundleURLCached(id) {
    var value = $a5e26b3134a5b8f0$var$bundleURL[id];
    if (!value) {
        value = $a5e26b3134a5b8f0$var$getBundleURL();
        $a5e26b3134a5b8f0$var$bundleURL[id] = value;
    }
    return value;
}
function $a5e26b3134a5b8f0$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $a5e26b3134a5b8f0$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $a5e26b3134a5b8f0$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $a5e26b3134a5b8f0$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$a5e26b3134a5b8f0$export$bdfd709ae4826697 = $a5e26b3134a5b8f0$var$getBundleURLCached;
$a5e26b3134a5b8f0$export$c9e73fbda7da57b6 = $a5e26b3134a5b8f0$var$getBaseURL;
$a5e26b3134a5b8f0$export$5a759dc7a1cfb72a = $a5e26b3134a5b8f0$var$getOrigin;

});

var $a8ef61f3e225ae8d$exports = {};


(parcelRequire("2X0P9")).register((parcelRequire("eeZWf")).getBundleURL("5mzGI"), JSON.parse('["5mzGI","index.20446334.js","4x7s8","1.4b4d4b64.png","bo8qy","2.50e6e306.png","efvcU","3.d5393261.png","8M5iA","4.89729799.png","8nvzC","5.fa7fdba0.png","5hp0O","6.e32653c5.png","01Ij5","7.716383dd.png","72F92","8.26b4c27b.png","2Pxes","9.f733ee91.png","6F4hs","10.e000c45a.png","2Zb0I","11.2620c7ca.png","4QPIi","12.e56e04fc.png","7ANvN","13.042e43b8.png","do5WL","14.b19e847c.png","9Usba","15.9e75e782.png","32vX0","16.431d4a37.png","aqlry","17.f4d6dc6f.png","hViXV","18.87b3fb99.png","5lYW2","19.26e9cd2f.png","3A3Ug","20.d979a9c3.png","3oNbq","21.f8abd812.png","dmWpz","22.a4f11bf1.png","1y1qX","23.a230dcd1.png","1PbCH","24.bf1c7797.png","7aMy2","25.600ed89f.png","i2twt","26.80b1524f.png","fmegU","27.9cf10421.png","uwbis","28.7ed5edc7.png","Tt1VP","29.6b695a98.png","7CyVR","30.38e4e9ab.png","eprC4","31.bed4a148.png","79h1l","32.0b9fa628.png","6Go9L","33.b8130304.png","jElLM","34.44c0618f.png","d4TZP","35.2c63ac43.png","11qKr","36.efe792db.png","c2lwy","37.7e79ebd8.png","9c27T","38.bc3e4804.png","10QZ5","39.91d3567c.png","9XX5p","40.da18d44e.png","h9LVA","41.416df1c7.png","egN1w","42.3a34dc1f.png","7jJoR","43.5ba578ad.png","aITPf","44.05096ed2.png","jcd8Y","45.4037bc25.png","44NjF","46.d77eb262.png","64oeH","47.a3c5818a.png","aZ9O0","48.907e0e56.png","a6Vbd","49.53f70f63.png","bj4re","50.fcb823af.png","jhApE","51.5e0d2f66.png","ayG48","52.64ff298f.png","3Puix","53.0b398a42.png","iDyWw","54.d728ffac.png","5WAP9","55.153730f8.png","gfYGX","56.b65ff898.png","WjRzo","57.a7099aa7.png","geNv6","58.8fae3ad2.png","2cc88","59.1bd548ba.png","61tfq","60.65ae3232.png","eWuh1","61.8dae416a.png","gNszj","62.b1fdfcff.png","kUbmH","63.925d6784.png","5lzpH","64.9783d915.png","6ztIg","65.6b146544.png","gOMVB","66.77e608a2.png","6NIiP","67.ede302b3.png","3pRKL","i0.9ebb77d9.png","hI1bw","i1.5d533fa9.png","9AeBc","i2.3e0a7ae3.png","4Oo9h","i4.08f436fc.png"]'));

var $d0bd3f77ced387c6$exports = {};

$d0bd3f77ced387c6$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "1.4b4d4b64.png";


var $32229d94b811f8ab$exports = {};

$32229d94b811f8ab$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "2.50e6e306.png";


var $e4647945c215f84a$exports = {};

$e4647945c215f84a$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "3.d5393261.png";


var $b602d50a6027a125$exports = {};

$b602d50a6027a125$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "4.89729799.png";


var $8f04e2eb4725ff65$exports = {};

$8f04e2eb4725ff65$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "5.fa7fdba0.png";


var $ee7267954bcaf75d$exports = {};

$ee7267954bcaf75d$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "6.e32653c5.png";


var $7bd520d60568efa0$exports = {};

$7bd520d60568efa0$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "7.716383dd.png";


var $add7d65da7fd0b7f$exports = {};

$add7d65da7fd0b7f$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "8.26b4c27b.png";


var $1e5d04f328527105$exports = {};

$1e5d04f328527105$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "9.f733ee91.png";


var $50314ce84e31890e$exports = {};

$50314ce84e31890e$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "10.e000c45a.png";


var $1ccc49c4940c7cba$exports = {};

$1ccc49c4940c7cba$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "11.2620c7ca.png";


var $aa87f17e26d17ce7$exports = {};

$aa87f17e26d17ce7$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "12.e56e04fc.png";


var $4d50d85e4dc40047$exports = {};

$4d50d85e4dc40047$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "13.042e43b8.png";


var $663355139802f274$exports = {};

$663355139802f274$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "14.b19e847c.png";


var $87281158c10f51ae$exports = {};

$87281158c10f51ae$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "15.9e75e782.png";


var $97917bf22a6d1016$exports = {};

$97917bf22a6d1016$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "16.431d4a37.png";


var $c1725df4e7bb8817$exports = {};

$c1725df4e7bb8817$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "17.f4d6dc6f.png";


var $8b59ee741186185d$exports = {};

$8b59ee741186185d$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "18.87b3fb99.png";


var $f620276223ce2a83$exports = {};

$f620276223ce2a83$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "19.26e9cd2f.png";


var $110fdeb1e50bda58$exports = {};

$110fdeb1e50bda58$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "20.d979a9c3.png";


var $f821457723e32713$exports = {};

$f821457723e32713$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "21.f8abd812.png";


var $9040a3f4bf7e03a9$exports = {};

$9040a3f4bf7e03a9$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "22.a4f11bf1.png";


var $d3d13020d319f0c7$exports = {};

$d3d13020d319f0c7$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "23.a230dcd1.png";


var $ad14c446d27ee378$exports = {};

$ad14c446d27ee378$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "24.bf1c7797.png";


var $a8d1fea4c4dd30e1$exports = {};

$a8d1fea4c4dd30e1$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "25.600ed89f.png";


var $ebbcda8072afe5fb$exports = {};

$ebbcda8072afe5fb$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "26.80b1524f.png";


var $88610b20de63c4b2$exports = {};

$88610b20de63c4b2$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "27.9cf10421.png";


var $2b6406b0835445a3$exports = {};

$2b6406b0835445a3$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "28.7ed5edc7.png";


var $5f100a4f03e4d754$exports = {};

$5f100a4f03e4d754$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "29.6b695a98.png";


var $0ac16430e17695b8$exports = {};

$0ac16430e17695b8$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "30.38e4e9ab.png";


var $b0c4e7930d46d37b$exports = {};

$b0c4e7930d46d37b$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "31.bed4a148.png";


var $844961624f3d0874$exports = {};

$844961624f3d0874$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "32.0b9fa628.png";


var $f393697cb1ea1db5$exports = {};

$f393697cb1ea1db5$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "33.b8130304.png";


var $3bb7fe09b600ca5a$exports = {};

$3bb7fe09b600ca5a$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "34.44c0618f.png";


var $f18bc00bd8613c74$exports = {};

$f18bc00bd8613c74$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "35.2c63ac43.png";


var $e2965711d8ca2fad$exports = {};

$e2965711d8ca2fad$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "36.efe792db.png";


var $2ac1f90739ec28a0$exports = {};

$2ac1f90739ec28a0$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "37.7e79ebd8.png";


var $fea642c498ffe631$exports = {};

$fea642c498ffe631$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "38.bc3e4804.png";


var $2c588fcf3bd28bc9$exports = {};

$2c588fcf3bd28bc9$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "39.91d3567c.png";


var $eb7c54cd0735a408$exports = {};

$eb7c54cd0735a408$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "40.da18d44e.png";


var $fb2ee78439699fe2$exports = {};

$fb2ee78439699fe2$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "41.416df1c7.png";


var $fff2a6907197884e$exports = {};

$fff2a6907197884e$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "42.3a34dc1f.png";


var $e78ef15c67848c62$exports = {};

$e78ef15c67848c62$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "43.5ba578ad.png";


var $a921ad3cae28348b$exports = {};

$a921ad3cae28348b$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "44.05096ed2.png";


var $b8c9c9ffa0e268cd$exports = {};

$b8c9c9ffa0e268cd$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "45.4037bc25.png";


var $e79f83e5486254f9$exports = {};

$e79f83e5486254f9$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "46.d77eb262.png";


var $ddc0b843ce6bd501$exports = {};

$ddc0b843ce6bd501$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "47.a3c5818a.png";


var $1b7d4485d9b8d8de$exports = {};

$1b7d4485d9b8d8de$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "48.907e0e56.png";


var $b46f87e05f3fff8d$exports = {};

$b46f87e05f3fff8d$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "49.53f70f63.png";


var $00fcf59723c3caf6$exports = {};

$00fcf59723c3caf6$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "50.fcb823af.png";


var $51c2a50d19e9da5d$exports = {};

$51c2a50d19e9da5d$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "51.5e0d2f66.png";


var $763fb1a38a11706c$exports = {};

$763fb1a38a11706c$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "52.64ff298f.png";


var $c69fb08e2bca34c9$exports = {};

$c69fb08e2bca34c9$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "53.0b398a42.png";


var $1c09638b6a7d4741$exports = {};

$1c09638b6a7d4741$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "54.d728ffac.png";


var $00b4dbcce760fceb$exports = {};

$00b4dbcce760fceb$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "55.153730f8.png";


var $632d3e50409f8a74$exports = {};

$632d3e50409f8a74$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "56.b65ff898.png";


var $99c8a00d93c514ee$exports = {};

$99c8a00d93c514ee$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "57.a7099aa7.png";


var $b85d3ed776cc6873$exports = {};

$b85d3ed776cc6873$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "58.8fae3ad2.png";


var $7923443eeb308f2e$exports = {};

$7923443eeb308f2e$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "59.1bd548ba.png";


var $3c7a1fad68e2deea$exports = {};

$3c7a1fad68e2deea$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "60.65ae3232.png";


var $3e21a151001274ff$exports = {};

$3e21a151001274ff$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "61.8dae416a.png";


var $62c19a5524a84204$exports = {};

$62c19a5524a84204$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "62.b1fdfcff.png";


var $c59a0937d03ae08e$exports = {};

$c59a0937d03ae08e$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "63.925d6784.png";


var $d93c9fb7aacdb180$exports = {};

$d93c9fb7aacdb180$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "64.9783d915.png";


var $63dc66a97cca1769$exports = {};

$63dc66a97cca1769$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "65.6b146544.png";


var $d32eb3556fb74d94$exports = {};

$d32eb3556fb74d94$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "66.77e608a2.png";


var $bca90f9773fa4cac$exports = {};

$bca90f9773fa4cac$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "67.ede302b3.png";


var $bb42cd6b72fa4a69$exports = {};

$bb42cd6b72fa4a69$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "i0.9ebb77d9.png";


var $b3032400af5457c3$exports = {};

$b3032400af5457c3$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "i1.5d533fa9.png";


var $7f1f3e0088ccee41$exports = {};

$7f1f3e0088ccee41$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "i2.3e0a7ae3.png";


var $89c8946d87ed7d35$exports = {};

$89c8946d87ed7d35$exports = (parcelRequire("eeZWf")).getBundleURL("5mzGI") + "i4.08f436fc.png";


const $6814cd811eee9739$var$bopomofo = {
    1: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($d0bd3f77ced387c6$exports))),
        name: "\u3105",
        value: "1"
    },
    2: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($32229d94b811f8ab$exports))),
        name: "\u3106",
        value: "2"
    },
    3: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($e4647945c215f84a$exports))),
        name: "\u3107",
        value: "3"
    },
    4: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($b602d50a6027a125$exports))),
        name: "\u3108",
        value: "4"
    },
    5: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($8f04e2eb4725ff65$exports))),
        name: '\u3105"',
        value: "5"
    },
    6: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($ee7267954bcaf75d$exports))),
        name: '\u3106"',
        value: "6"
    },
    7: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($7bd520d60568efa0$exports))),
        name: '\u3107"',
        value: "7"
    },
    8: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($add7d65da7fd0b7f$exports))),
        name: "\u3108f",
        value: "8"
    },
    9: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($1e5d04f328527105$exports))),
        name: "\u3108v",
        value: "9"
    },
    10: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($50314ce84e31890e$exports))),
        name: "\u6469\u64E6\u3109",
        value: "10"
    },
    11: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($1ccc49c4940c7cba$exports))),
        name: "\u6469\u64E6\u310A",
        value: "11"
    },
    12: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($aa87f17e26d17ce7$exports))),
        name: "\u310B",
        value: "12"
    },
    13: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($4d50d85e4dc40047$exports))),
        name: "\u310C",
        value: "13"
    },
    14: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($663355139802f274$exports))),
        name: "\u3109^\u3117",
        value: "14"
    },
    15: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($87281158c10f51ae$exports))),
        name: "\u310A^\u3118",
        value: "15"
    },
    16: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($97917bf22a6d1016$exports))),
        name: '\u3109"',
        value: "16"
    },
    17: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($c1725df4e7bb8817$exports))),
        name: '\u310A"',
        value: "17"
    },
    18: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($8b59ee741186185d$exports))),
        name: "\u310B~",
        value: "18"
    },
    19: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($f620276223ce2a83$exports))),
        name: "\u310C~",
        value: "19"
    },
    20: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($110fdeb1e50bda58$exports))),
        name: "\u310C-",
        value: "20"
    },
    21: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($f821457723e32713$exports))),
        name: "\u310D",
        value: "21"
    },
    22: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($9040a3f4bf7e03a9$exports))),
        name: "\u310E",
        value: "22"
    },
    23: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($d3d13020d319f0c7$exports))),
        name: "\u310F",
        value: "23"
    },
    24: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($ad14c446d27ee378$exports))),
        name: '\u310D^"',
        value: "24"
    },
    25: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($a8d1fea4c4dd30e1$exports))),
        name: '\u310E^"',
        value: "25"
    },
    26: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($ebbcda8072afe5fb$exports))),
        name: "\u3110",
        value: "26"
    },
    27: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($88610b20de63c4b2$exports))),
        name: "\u3111",
        value: "27"
    },
    28: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($2b6406b0835445a3$exports))),
        name: "\u3112",
        value: "28"
    },
    29: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($5f100a4f03e4d754$exports))),
        name: "*\u3110*",
        value: "29"
    },
    30: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($0ac16430e17695b8$exports))),
        name: "*\u3111*",
        value: "30"
    },
    31: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($b0c4e7930d46d37b$exports))),
        name: "*\u3112*",
        value: "31"
    },
    32: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($844961624f3d0874$exports))),
        name: "\u3113",
        value: "32"
    },
    33: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($f393697cb1ea1db5$exports))),
        name: "\u3114",
        value: "33"
    },
    34: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($3bb7fe09b600ca5a$exports))),
        name: "\u3115",
        value: "34"
    },
    35: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($f18bc00bd8613c74$exports))),
        name: "\u3116",
        value: "35"
    },
    36: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($e2965711d8ca2fad$exports))),
        name: "\u3117",
        value: "36"
    },
    37: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($2ac1f90739ec28a0$exports))),
        name: "\u3118",
        value: "37"
    },
    38: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($fea642c498ffe631$exports))),
        name: "\u3119",
        value: "38"
    },
    39: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($2c588fcf3bd28bc9$exports))),
        name: "Z",
        value: "39"
    },
    40: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($eb7c54cd0735a408$exports))),
        name: "\u3119^\u0398",
        value: "40"
    },
    41: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($fb2ee78439699fe2$exports))),
        name: "Z^\u0398",
        value: "41"
    },
    42: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($fff2a6907197884e$exports))),
        name: "\u311A",
        value: "42"
    },
    43: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($e78ef15c67848c62$exports))),
        name: "\u311B",
        value: "43"
    },
    44: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($a921ad3cae28348b$exports))),
        name: "\u311C",
        value: "44"
    },
    45: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($b8c9c9ffa0e268cd$exports))),
        name: "\u311D",
        value: "45"
    },
    46: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($e79f83e5486254f9$exports))),
        name: "\u5FC3\u311A",
        value: "46"
    },
    47: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($ddc0b843ce6bd501$exports))),
        name: "\u3126",
        value: "47"
    },
    48: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($1b7d4485d9b8d8de$exports))),
        name: "\u3127^\u311D",
        value: "48"
    },
    49: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($b46f87e05f3fff8d$exports))),
        name: "\u311A^\u311D",
        value: "49"
    },
    50: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($00fcf59723c3caf6$exports))),
        name: "\u3120^\u311D",
        value: "50"
    },
    51: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($51c2a50d19e9da5d$exports))),
        name: "\u311E",
        value: "51"
    },
    52: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($763fb1a38a11706c$exports))),
        name: "\u311F",
        value: "52"
    },
    53: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($c69fb08e2bca34c9$exports))),
        name: "\u3120",
        value: "53"
    },
    54: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($1c09638b6a7d4741$exports))),
        name: "\u3121",
        value: "54"
    },
    55: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($00b4dbcce760fceb$exports))),
        name: "\u3122",
        value: "55"
    },
    56: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($632d3e50409f8a74$exports))),
        name: "\u3123",
        value: "56"
    },
    57: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($99c8a00d93c514ee$exports))),
        name: "\u3124",
        value: "57"
    },
    58: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($b85d3ed776cc6873$exports))),
        name: "\u3125",
        value: "58"
    },
    59: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($7923443eeb308f2e$exports))),
        name: "\u3127",
        value: "59"
    },
    60: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($3c7a1fad68e2deea$exports))),
        name: "\u3128",
        value: "60"
    },
    61: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($3e21a151001274ff$exports))),
        name: "\u3129",
        value: "61"
    },
    62: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($62c19a5524a84204$exports))),
        name: "\u311C^\u3127",
        value: "62"
    },
    63: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($c59a0937d03ae08e$exports))),
        name: "\u311C^\u3128",
        value: "63"
    },
    64: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($d93c9fb7aacdb180$exports))),
        name: "\u3128^\u311C",
        value: "64"
    },
    65: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($63dc66a97cca1769$exports))),
        name: "\u3128^i\u3113",
        value: "65"
    },
    66: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($d32eb3556fb74d94$exports))),
        name: "\u3127\u3127",
        value: "66"
    },
    67: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($bca90f9773fa4cac$exports))),
        name: "\u3118^\u0398",
        value: "67"
    },
    68: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($bb42cd6b72fa4a69$exports))),
        name: "\u8F15\u8072",
        value: "68"
    },
    69: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($b3032400af5457c3$exports))),
        name: "\u3127\u8072",
        value: "69"
    },
    70: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($7f1f3e0088ccee41$exports))),
        name: "\u4E8C\u8072",
        value: "70"
    },
    71: {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($89c8946d87ed7d35$exports))),
        name: "\u56DB\u8072",
        value: "71"
    }
};
var $6814cd811eee9739$export$2e2bcd8739ae039 = $6814cd811eee9739$var$bopomofo;


let $e039ef6aaef3acdd$var$currentInputElement = null;
let $e039ef6aaef3acdd$var$isKeyboardVisible = false;
function $e039ef6aaef3acdd$export$9852ddb15aeb7ca3(container) {
    const keyboardWrapper = document.createElement("div");
    keyboardWrapper.id = "sor-keyboard-wrapper";
    keyboardWrapper.style.display = "none";
    const toggleButton = document.createElement("button");
    toggleButton.textContent = "\u986F\u793A/\u96B1\u85CF\u9375\u76E4";
    toggleButton.id = "toggle-keyboard-button";
    toggleButton.addEventListener("click", $e039ef6aaef3acdd$var$toggleKeyboard);
    const keyboardContainer = document.createElement("div");
    keyboardContainer.id = "sor-keyboard";
    keyboardContainer.className = "keyboard-container";
    // 創建鍵盤佈局
    const keyboardLayout = [
        [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ],
        [
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22
        ],
        [
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33
        ],
        [
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44
        ],
        [
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55
        ],
        [
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67
        ],
        [
            68,
            69,
            70,
            71
        ],
        [
            "clear",
            "backspace"
        ]
    ];
    // 創建鍵盤
    keyboardLayout.forEach((row)=>{
        const rowElement = document.createElement("div");
        rowElement.className = "keyboard-row";
        row.forEach((key)=>{
            const keyElement = document.createElement("button");
            keyElement.className = "keyboard-key";
            keyElement.type = "button";
            if (key === "clear") {
                keyElement.textContent = "\u6E05\u9664";
                keyElement.classList.add("function-key", "clear-key");
                keyElement.addEventListener("click", $e039ef6aaef3acdd$var$clearInput);
            } else if (key === "backspace") {
                keyElement.textContent = "\u522A\u9664";
                keyElement.classList.add("function-key", "backspace-key");
                keyElement.addEventListener("click", $e039ef6aaef3acdd$var$backspace);
            } else {
                keyElement.dataset.value = (0, $6814cd811eee9739$export$2e2bcd8739ae039)[key].value;
                keyElement.dataset.image = (0, $6814cd811eee9739$export$2e2bcd8739ae039)[key].image;
                const imgElement = document.createElement("img");
                imgElement.src = (0, $6814cd811eee9739$export$2e2bcd8739ae039)[key].image;
                imgElement.alt = (0, $6814cd811eee9739$export$2e2bcd8739ae039)[key].name;
                imgElement.dataset.name = (0, $6814cd811eee9739$export$2e2bcd8739ae039)[key].name;
                imgElement.className = "keyboard-key-image";
                keyElement.appendChild(imgElement);
                keyElement.addEventListener("click", ()=>$e039ef6aaef3acdd$var$addInputImage(keyElement.dataset.image, keyElement.dataset.value, (0, $6814cd811eee9739$export$2e2bcd8739ae039)[key].name));
            }
            rowElement.appendChild(keyElement);
        });
        keyboardContainer.appendChild(rowElement);
    });
    keyboardWrapper.appendChild(keyboardContainer);
    container.appendChild(toggleButton);
    container.appendChild(keyboardWrapper);
}
function $e039ef6aaef3acdd$var$toggleKeyboard() {
    const keyboardWrapper = document.getElementById("sor-keyboard-wrapper");
    const toggleButton = document.getElementById("toggle-keyboard-button");
    if (!$e039ef6aaef3acdd$var$currentInputElement || !$e039ef6aaef3acdd$var$currentInputElement.isContentEditable) {
        alert("\u8ACB\u5148\u9078\u64C7\u4E00\u500B\u8F38\u5165\u6846");
        return;
    }
    $e039ef6aaef3acdd$var$isKeyboardVisible = !$e039ef6aaef3acdd$var$isKeyboardVisible;
    keyboardWrapper.style.display = $e039ef6aaef3acdd$var$isKeyboardVisible ? "block" : "none";
    toggleButton.textContent = $e039ef6aaef3acdd$var$isKeyboardVisible ? "\u96B1\u85CF\u9375\u76E4" : "\u986F\u793A\u9375\u76E4";
}
function $e039ef6aaef3acdd$export$88f7b48baf778b50(inputElement) {
    $e039ef6aaef3acdd$var$currentInputElement = inputElement;
}
function $e039ef6aaef3acdd$var$addInputImage(imageSrc, value, name) {
    if (!$e039ef6aaef3acdd$var$currentInputElement) {
        console.warn("No input element focused. Cannot add image.");
        return;
    }
    // Check if the current input element is contentEditable
    if (!$e039ef6aaef3acdd$var$currentInputElement.isContentEditable) {
        console.warn("Current input element is not contentEditable. Cannot add image.");
        return;
    }
    const imgElement = document.createElement("img");
    imgElement.src = imageSrc;
    imgElement.alt = value;
    imgElement.dataset.name = name;
    imgElement.className = "input-image";
    imgElement.dataset.value = value;
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);
    // Check if the range is within the current input element
    if (!$e039ef6aaef3acdd$var$currentInputElement.contains(range.commonAncestorContainer)) {
        console.warn("Selection is outside the current input element. Focusing and moving cursor to the end.");
        $e039ef6aaef3acdd$var$currentInputElement.focus();
        range.selectNodeContents($e039ef6aaef3acdd$var$currentInputElement);
        range.collapse(false); // Move cursor to the end
    }
    range.deleteContents();
    range.insertNode(imgElement);
    range.setStartAfter(imgElement);
    range.setEndAfter(imgElement);
    selection.removeAllRanges();
    selection.addRange(range);
    $e039ef6aaef3acdd$var$currentInputElement.focus();
    // Add this line to update the hidden input
    $e039ef6aaef3acdd$var$updateHiddenInput($e039ef6aaef3acdd$var$currentInputElement);
}
function $e039ef6aaef3acdd$var$clearInput() {
    if (!$e039ef6aaef3acdd$var$currentInputElement) return;
    $e039ef6aaef3acdd$var$currentInputElement.innerHTML = "";
    $e039ef6aaef3acdd$var$currentInputElement.focus();
}
function $e039ef6aaef3acdd$var$backspace() {
    if (!$e039ef6aaef3acdd$var$currentInputElement) return;
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);
    if (range.collapsed) {
        const currentNode = range.startContainer;
        const offset = range.startOffset;
        if (currentNode === $e039ef6aaef3acdd$var$currentInputElement && offset === 0) return;
        if (currentNode.nodeType === Node.TEXT_NODE) {
            if (offset > 0) {
                currentNode.textContent = currentNode.textContent.slice(0, offset - 1) + currentNode.textContent.slice(offset);
                range.setStart(currentNode, offset - 1);
                range.setEnd(currentNode, offset - 1);
            } else {
                const previousSibling = currentNode.previousSibling;
                if (previousSibling) {
                    if (previousSibling.nodeType === Node.TEXT_NODE) {
                        const newOffset = previousSibling.textContent.length;
                        previousSibling.textContent += currentNode.textContent;
                        currentNode.remove();
                        range.setStart(previousSibling, newOffset);
                        range.setEnd(previousSibling, newOffset);
                    } else previousSibling.remove();
                }
            }
        } else {
            const previousSibling = currentNode.childNodes[offset - 1];
            if (previousSibling) {
                previousSibling.remove();
                range.setStart(currentNode, offset - 1);
                range.setEnd(currentNode, offset - 1);
            }
        }
    } else range.deleteContents();
    selection.removeAllRanges();
    selection.addRange(range);
    $e039ef6aaef3acdd$var$currentInputElement.focus();
    // Add this line to update the hidden input
    $e039ef6aaef3acdd$var$updateHiddenInput($e039ef6aaef3acdd$var$currentInputElement);
}
// Add this new function to update the hidden input
function $e039ef6aaef3acdd$var$updateHiddenInput(inputElement) {
    const hiddenInputId = `hidden-${inputElement.id.split("-").pop()}`;
    const hiddenInput = document.getElementById(hiddenInputId);
    if (hiddenInput) {
        hiddenInput.value = $e039ef6aaef3acdd$var$convertEditableDivContent(inputElement);
        console.log(`Updated hidden input ${hiddenInputId} with value: ${hiddenInput.value}`);
    } else console.warn(`Hidden input not found for ${inputElement.id}`);
}
// Update this function to connect multiple images with a period
function $e039ef6aaef3acdd$var$convertEditableDivContent(editableDiv) {
    let result = [];
    let hasImage = false;
    editableDiv.childNodes.forEach((node)=>{
        if (node.nodeType === Node.TEXT_NODE) result.push(node.textContent.trim());
        else if (node.nodeName === "IMG") {
            hasImage = true;
            result.push(node.dataset.value || node.alt);
        } else if (node.nodeName === "BR") result.push("\n");
    });
    // If there are multiple images, join them with periods
    if (hasImage) return result.filter((item)=>item !== "").join(".");
    else return result.join("").trim();
}
function $e039ef6aaef3acdd$export$e7a10d3883fd5a3a(inputElement) {
    let values = [];
    function extractFromNode(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.tagName === "IMG") {
                // 如果是圖片元素，提取 data-value 屬性
                const value = node.dataset.value;
                if (value) values.push(value);
            } else if (node.tagName === "BR") // 如果是換行元素，添加換行符
            values.push("\n");
            else // 遞歸處理其他元素的子節點
            Array.from(node.childNodes).forEach(extractFromNode);
        } else if (node.nodeType === Node.TEXT_NODE) // 如果是文本節點，直接添加文本內容
        values.push(node.textContent);
    }
    // 從根節點開始遞歸處理
    extractFromNode(inputElement);
    // 將所有值連接成一個字符串並返回
    return values.join("");
}


const $1aff465550c1c1fe$var$commonSettings = {
    title: "\u856D\u535A\u58EBSoR\u7F8E\u8A9E\u6B63\u97F3\u5E2B\u300C\u807D\u529B\u7B46\u8A66\u6E2C\u9A57\uFF2A\u300D",
    description: [
        "\uFF08\u6E2C\u9A57\u8AAA\u660E\uFF09 \u672C\u6E2C\u9A57\u5171\u4E09\u90E8\u5206\uFF1A",
        "\u3010\u7B2C\u4E00\u90E8\u5206\u3011\u8ACB\u53C3\u7167\u300A\u81FA\u7063\u96D9\u8A9E\u6CE8\u97F3\u7B26\u865F\u8868\u300B\u4E26\u5728\u5C0D\u61C9\u984C\u865F\u4E2D\uFF0C\u5BEB\u51FA\u807D\u5230\u8072\u97F3\u7684\u7DE8\u865F\uFF08\u6BCF\u984C\u4E8C\u5206\uFF0C\u5171\u5341\u984C\uFF0C\u4F54\u4E8C\u5341\u5206\uFF09",
        "\u3010\u7B2C\u4E8C\u90E8\u5206\u3011\u8ACB\u53C3\u7167\u300A\u81FA\u7063\u96D9\u8A9E\u6CE8\u97F3\u7B26\u865F\u8868\u300B\u4E26\u5728\u5C0D\u61C9\u984C\u865F\u4E2D\uFF0C\u5BEB\u51FA\u97F3\u6A94\u6240\u5FF5CVC\u7D44\u5408\u8072\u97F3\u7684\u7DE8\u865F \uFF08\u6BCF\u984C\u4E09\u5206\uFF0C\u8A08\u5206\u65B9\u5F0F\u70BA\u5B50\u97F3\u4E00\u5206\uFF1B\u6BCD\u97F3\u5169\u5206\u6263\u5B8C\u70BA\u6B62\uFF0C\u5171\u4E8C\u5341\u4E94\u984C\uFF0C\u4F54\u4E03\u5341\u4E94\u5206\uFF09",
        "\u3010\u7B2C\u4E09\u90E8\u5206\u3011\u8ACB\u807D\u5B78\u54E1\u97F3\u6A94\uFF0C\u5148\u627E\u51FA\u5C0D\u65B9\u503C\u5F97\u9F13\u52F5\u7684\u90E8\u5206\uFF0C\u4E26\u5BEB\u51FA\u4E00\u9EDE\uFF0C\u8A72\u5B78\u54E1\u767C\u97F3\u6240\u7522\u751F\u660E\u986F\u7684\u504F\u79FB\u8AA4\u5DEE\uFF0C\u518D\u8A66\u7B54\uFF0C\u82E5\u60A8\u662F\u6B63\u97F3\u5E2B\u6703\u5982\u4F55\u5F15\u5C0E\u8207\u56DE\u8986\u3002\uFF08\u5171\u4E00\u984C\uFF0C\u4F54\u4E94\u5206\uFF09",
        "\uFF0A\u6CE8\u610F\u4E00\uFF1A\u672C\u6E2C\u9A57\u56DE\u7B54\u524D\u5169\u5927\u984C\u6642\uFF0C\u53EA\u9700\u586B\u5BEB\u807D\u5230\u8A72\u8072\u97F3\u7B26\u865F\u7684\u7DE8\u865F(\u975E\u586B\u7DE8\u865F\u4E0D\u8A08\u5206)",
        "\uFF0A\u6CE8\u610F\u4E8C\uFF1A\u56DE\u7B54\u7B2C\u4E8C\u90E8\u5206\u984C\u76EE\u6642\uFF0C\u8ACB\u6309\u7167CVC\u767C\u97F3\u5148\u5F8C\u9806\u5E8F\u586B\u5BEB\uFF0C\u4E26\u5728\u7DE8\u865F\u4E4B\u9593\u8ACB\u52A0\u4E0A\uFF08.\uFF09\u505A\u5340\u9694 ex: 13.53.22\u3002",
        "\uFF0A\u7E3D\u5206\u78BA\u8A8D\u5F8C\u5C07\u5BC4\u767C\u6210\u7E3E\u81F3\u672C\u8868\u55AE\u8A18\u9304\u4E4B\u4FE1\u7BB1\uFF0C\u8ACB\u52D9\u5FC5\u586B\u5BEB\u6B63\u78BA\u3002",
        "\uFF0A\u7E3D\u5206\u9700\u905490\u5206\u4EE5\u4E0A\uFF0C\u65B9\u9054\u5230\u6B63\u97F3\u5E2B\u7B46\u8A66\u53CA\u683C\u6A19\u6E96\u3002"
    ],
    endDescription: "\u7E3D\u5206\u78BA\u8A8D\u5F8C\u5C07\u5BC4\u767C\u6210\u7E3E\u81F3\u672C\u8868\u55AE\u8A18\u9304\u4E4B\u4FE1\u7BB1\uFF0C\u8ACB\u52D9\u5FC5\u586B\u5BEB\u6B63\u78BA\u3002",
    commonQuestion: [
        {
            id: "entry.172276031",
            questionTitle: "\u5E2B\u8CC7\u73ED\u5225",
            questionType: "radio",
            questionOptions: [
                "SoR\u5E2B\u8CC7\u3127\u73ED",
                "SoR\u5E2B\u8CC7\u4E8C\u73ED",
                "SoR\u5E2B\u8CC7\u4E09\u73ED",
                "SoR\u5E2B\u8CC7\u56DB\u73ED",
                "SoR\u5E2B\u8CC7\u4E94\u73ED",
                "SoR\u5E2B\u8CC7\u516D\u73ED",
                "SoR\u5E2B\u8CC7\u4E03\u73ED",
                "SoR\u5E2B\u8CC7\u516B\u73ED",
                "SoR\u5E2B\u8CC7\u4E5D\u73ED",
                "SoR\u5E2B\u8CC7\u5341\u73ED"
            ]
        },
        {
            id: "entry.573948846",
            questionTitle: "\u5E2B\u8CC7\u59D3\u540D",
            questionType: "text"
        },
        {
            id: "entry.2033835759",
            questionTitle: "\u8003\u8A66\u5E8F\u865F",
            questionDescription: "\u5982\u4E0A\u7DDA\u540D\u7A31\u70BA01-\u5B89\u8FEA\u54E5\uFF0C\u8ACB\u8F38\u516501",
            questionType: "text",
            inputType: "number"
        }
    ],
    googleFormResponseURL: "https://docs.google.com/forms/u/0/d/e/1FAIpQLSfpT12Ly2Be0AKOnnuAlsDwMVItwbYZaeXkT5C_XxSCccaR8A/formResponse"
};
const $1aff465550c1c1fe$var$part1Settings = {
    title: "\u3010\u7B2C\u4E00\u90E8\u5206\u3011 \u807D\u51FA\u300A\u81FA\u7063\u96D9\u8A9E\u7B26\u865F\u8868\u300B\u500B\u5225\u7B26\u865F  \uFF08\u6BCF\u984C\u5169\u5206\uFF0C\u5171\u5341\u984C\uFF09",
    onlyCustomKeyboard: true,
    bopomofoKeyboard: true
};
const $1aff465550c1c1fe$var$part1Questions = [
    {
        id: "entry.1062532100",
        questionTitle: "\u7B2C\u4E00\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.315045706",
        questionTitle: "\u7B2C\u4E8C\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.424153291",
        questionTitle: "\u7B2C\u4E09\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.886790481",
        questionTitle: "\u7B2C\u56DB\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.168045119",
        questionTitle: "\u7B2C\u4E94\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.757586012",
        questionTitle: "\u7B2C\u516D\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.2021541880",
        questionTitle: "\u7B2C\u4E03\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1791408647",
        questionTitle: "\u7B2C\u516B\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1922610091",
        questionTitle: "\u7B2C\u4E5D\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1452080461",
        questionTitle: "\u7B2C\u5341\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    }
];
const $1aff465550c1c1fe$var$part2Settings = {
    title: "\u3010\u7B2C\u4E8C\u90E8\u5206\u3011 \u807D\u51FACVC\u7D44\u5408\u7684\u8072\u97F3\uFF08 \u6BCF\u984C\u4E09\u5206\uFF0C\u5171\u4E8C\u5341\u4E94\u984C\uFF09",
    description: "\u8ACB\u807D\u97F3\u6A94\uFF0C\u5728\u5C0D\u61C9\u984C\u865F\u4E2D\uFF0C\u4F9D\u5E8F\u5BEB\u51FACVC\u7D44\u5408\u7684\u8072\u97F3\u5728\u300A\u81FA\u7063\u96D9\u8A9E\u6CE8\u97F3\u7B26\u865F\u8868\u300B\u7684\u7DE8\u865F",
    onlyCustomKeyboard: true,
    bopomofoKeyboard: true
};
const $1aff465550c1c1fe$var$part2Questions = [
    {
        id: "entry.129660470",
        questionTitle: "\u7B2C\u4E00\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.443571259",
        questionTitle: "\u7B2C\u4E8C\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.950072603",
        questionTitle: "\u7B2C\u4E09\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1691461409",
        questionTitle: "\u7B2C\u56DB\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1749489632",
        questionTitle: "\u7B2C\u4E94\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.2120291620",
        questionTitle: "\u7B2C\u516D\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.88536496",
        questionTitle: "\u7B2C\u4E03\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.743766707",
        questionTitle: "\u7B2C\u516B\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.325451342",
        questionTitle: "\u7B2C\u4E5D\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.602021393",
        questionTitle: "\u7B2C\u5341\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.480602353",
        questionTitle: "\u7B2C\u5341\u4E00\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.2082125563",
        questionTitle: "\u7B2C\u5341\u4E8C\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.204249988",
        questionTitle: "\u7B2C\u5341\u4E09\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.714185888",
        questionTitle: "\u7B2C\u5341\u56DB\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.505537057",
        questionTitle: "\u7B2C\u5341\u4E94\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1857846538",
        questionTitle: "\u7B2C\u5341\u516D\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.195684583",
        questionTitle: "\u7B2C\u5341\u4E03\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1248606910",
        questionTitle: "\u7B2C\u5341\u516B\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.621575898",
        questionTitle: "\u7B2C\u5341\u4E5D\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1219137104",
        questionTitle: "\u7B2C\u4E8C\u5341\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1817705071",
        questionTitle: "\u7B2C\u4E8C\u5341\u4E00\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1801778234",
        questionTitle: "\u7B2C\u4E8C\u5341\u4E8C\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.2144500851",
        questionTitle: "\u7B2C\u4E8C\u5341\u4E09\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.1230447615",
        questionTitle: "\u7B2C\u4E8C\u5341\u56DB\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    },
    {
        id: "entry.358450166",
        questionTitle: "\u7B2C\u4E8C\u5341\u4E94\u984C",
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "text"
    }
];
const $1aff465550c1c1fe$var$part3Settings = {
    title: "\u3010\u7B2C\u4E09\u90E8\u5206\u3011\u5075\u932F\u7D66\u56DE\u994B \uFF08\u6BCF\u984C\u4E94\u5206\uFF0C\u5171\u4E00\u984C\uFF09",
    description: [
        "1.\u8ACB\u807D\u5B78\u54E1\u97F3\u6A94\uFF0C\u5148\u627E\u51FA\u5C0D\u65B9\u503C\u5F97\u9F13\u52F5\u7684\u90E8\u5206\uFF0C\u4E26\u76E1\u53EF\u80FD\u5BEB\u4E0B\u8A72\u5B78\u54E1\u767C\u97F3\u6240\u7522\u751F\u7684\u504F\u79FB\u554F\u984C",
        "2.\u518D\u8A66\u7B54\u82E5\u60A8\u662F\u6B63\u97F3\u5E2B\uFF0C\u6703\u5982\u4F55\u5F15\u5C0E\u8207\u56DE\u8986"
    ],
    bopomofoKeyboard: true
};
const $1aff465550c1c1fe$var$part3Questions = [
    {
        id: "entry.164876408",
        questionTitle: "\u5075\u932F\u984C\uFF08\u3119\u3113\u3128\u311D stre\uFF09",
        questionDescription: "\u807D\u8A72\u5B78\u54E1\u97F3\u6A94\uFF0C\u7B54\u984C\u6642\u8ACB\u5148\u7C21\u77ED\u7CBE\u6E96\u5BEB\u51FA\u4E00\u9805\u60A8\u89C0\u5BDF\u5230\u5C0D\u65B9\u7684\u512A\u9EDE\uFF1B\u504F\u79FB\u90E8\u5206\u8ACB\u5BEB\u51FA\u4E3B\u8981\u5E0C\u671B\u5C0D\u65B9\u8ABF\u6574\u7684\u4E00\u9805\uFF0C\u4E26\u76E1\u53EF\u80FD\u689D\u5217\u8A73\u7B54\u5982\u4F55\u4E00\u6B65\u6B65\u5354\u52A9\u5C0D\u65B9\u8ABF\u97F3\u7684\u904E\u7A0B\u3002",
        questionHint: [
            "\u8B9A\u7F8E\u9F13\u52F5\u9EDE\uFF1A",
            "\u4E3B\u8981\u767C\u97F3\u554F\u984C\uFF1A",
            "\u8ABF\u6574\u65B9\u6CD5\uFF1A",
            "a.",
            "b.",
            "c.",
            "d."
        ],
        questionType: "audio",
        questionAudio: "https://example.com/audio/1.mp3",
        inputType: "textarea"
    }
];
const $1aff465550c1c1fe$var$exportData = {
    settings: $1aff465550c1c1fe$var$commonSettings,
    questions: [
        {
            settings: $1aff465550c1c1fe$var$part1Settings,
            questions: $1aff465550c1c1fe$var$part1Questions
        },
        {
            settings: $1aff465550c1c1fe$var$part2Settings,
            questions: $1aff465550c1c1fe$var$part2Questions
        },
        {
            settings: $1aff465550c1c1fe$var$part3Settings,
            questions: $1aff465550c1c1fe$var$part3Questions
        }
    ]
};
var $1aff465550c1c1fe$export$2e2bcd8739ae039 = $1aff465550c1c1fe$var$exportData;


function $7fa80a46c1067125$var$createTestHeader(settings) {
    const headerDiv = document.createElement("div");
    headerDiv.className = "test-header";
    const title = document.createElement("h1");
    title.textContent = settings.title;
    headerDiv.appendChild(title);
    const description = document.createElement("div");
    description.className = "test-description";
    description.innerHTML = settings.description.join("<br><br>");
    headerDiv.appendChild(description);
    return headerDiv;
}
function $7fa80a46c1067125$var$createEndDescription(settings) {
    const endDescription = document.createElement("div");
    endDescription.className = "end-description";
    endDescription.textContent = settings.endDescription;
    return endDescription;
}
function $7fa80a46c1067125$var$createTestContent(data) {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = (0, $1aff465550c1c1fe$export$2e2bcd8739ae039).settings.googleFormResponseURL;
    form.className = "test-content";
    // Create common questions section
    const commonQuestionsSection = $7fa80a46c1067125$var$createCommonQuestionsSection(data.settings.commonQuestion);
    form.appendChild(commonQuestionsSection);
    // Create main questions sections
    data.questions.forEach((section)=>{
        const sectionDiv = $7fa80a46c1067125$var$createSection(section);
        form.appendChild(sectionDiv);
    });
    return form;
}
function $7fa80a46c1067125$var$createCommonQuestionsSection(commonQuestions) {
    const sectionDiv = document.createElement("div");
    sectionDiv.className = "common-questions-section";
    const sectionTitle = document.createElement("h2");
    sectionTitle.textContent = "\u57FA\u672C\u8CC7\u6599";
    sectionDiv.appendChild(sectionTitle);
    commonQuestions.forEach((question)=>{
        const questionDiv = $7fa80a46c1067125$var$createCommonQuestion(question);
        sectionDiv.appendChild(questionDiv);
    });
    return sectionDiv;
}
function $7fa80a46c1067125$var$createCommonQuestion(question) {
    const questionDiv = document.createElement("div");
    questionDiv.className = "common-question";
    const title = document.createElement("h3");
    title.textContent = question.questionTitle;
    questionDiv.appendChild(title);
    if (question.questionDescription) {
        const description = document.createElement("p");
        description.textContent = question.questionDescription;
        questionDiv.appendChild(description);
    }
    if (question.questionType === "radio" && Array.isArray(question.questionOptions)) {
        const optionsContainer = document.createElement("div");
        optionsContainer.className = "radio-options";
        question.questionOptions.forEach((option, index)=>{
            const label = document.createElement("label");
            const radio = document.createElement("input");
            radio.type = "radio";
            radio.name = `${question.id}`; // 確保名稱唯一
            radio.value = option;
            radio.id = `question-${question.id}-option-${index}`;
            label.htmlFor = radio.id; // 增加可訪問性
            label.appendChild(radio);
            label.appendChild(document.createTextNode(option));
            optionsContainer.appendChild(label);
        });
        questionDiv.appendChild(optionsContainer);
    } else if (question.questionType === "text") {
        // Add answer title
        const answerTitle = document.createElement("h4");
        answerTitle.textContent = "\u56DE\u7B54";
        questionDiv.appendChild(answerTitle);
        const input = document.createElement("input");
        input.type = "text";
        input.id = `question-${question.id}`;
        input.name = question.id; // Add name attribute
        questionDiv.appendChild(input);
    } else console.warn(`Unsupported question type: ${question.questionType}`);
    return questionDiv;
}
function $7fa80a46c1067125$var$createSection(section) {
    const sectionDiv = document.createElement("div");
    sectionDiv.className = "test-section";
    if (section.settings) {
        const sectionTitle = document.createElement("h2");
        sectionTitle.textContent = section.settings.title;
        sectionDiv.appendChild(sectionTitle);
        if (section.settings.description) {
            const sectionDescription = document.createElement("div");
            sectionDescription.className = "section-description";
            sectionDescription.innerHTML = Array.isArray(section.settings.description) ? section.settings.description.join("<br><br>") : section.settings.description;
            sectionDiv.appendChild(sectionDescription);
        }
        // Store the global onlyCustomKeyboard setting
        const globalOnlyCustomKeyboard = section.settings.onlyCustomKeyboard || false;
        // Store the global bopomofoKeyboard setting
        const globalBopomofoKeyboard = section.settings.bopomofoKeyboard || false;
        if (section.questions) section.questions.forEach((question)=>{
            // Apply global setting to each question if not explicitly set
            if (globalOnlyCustomKeyboard && question.onlyCustomKeyboard === undefined) question.onlyCustomKeyboard = true;
            if (globalBopomofoKeyboard && question.bopomofoKeyboard === undefined) question.bopomofoKeyboard = true;
            const questionDiv = $7fa80a46c1067125$var$createQuestion(question);
            sectionDiv.appendChild(questionDiv);
        });
    }
    return sectionDiv;
}
function $7fa80a46c1067125$var$createQuestion(question) {
    const questionDiv = document.createElement("div");
    questionDiv.className = "question";
    const title = document.createElement("h3");
    title.textContent = question.questionTitle;
    questionDiv.appendChild(title);
    const description = document.createElement("p");
    description.textContent = question.questionDescription;
    questionDiv.appendChild(description);
    if (question.questionHint) {
        const hintContainer = document.createElement("div");
        const hintTitle = document.createElement("div");
        hintTitle.className = "question-hint-title";
        hintTitle.textContent = "\u63D0\u793A";
        hintContainer.appendChild(hintTitle);
        hintContainer.className = "question-hint";
        question.questionHint.forEach((hint)=>{
            const hintParagraph = document.createElement("p");
            hintParagraph.textContent = hint;
            hintContainer.appendChild(hintParagraph);
        });
        questionDiv.appendChild(hintContainer);
    }
    if (question.questionType === "audio") {
        const audioTitle = document.createElement("h4");
        audioTitle.textContent = question.audioTitle || "\u984C\u76EE\u97F3\u6A94"; // 使用問題中的 audioTitle，如果沒有則默認為 '題目音檔'
        questionDiv.appendChild(audioTitle);
        const audio = document.createElement("audio");
        audio.controls = true;
        audio.src = question.questionAudio;
        questionDiv.appendChild(audio);
    }
    if (question.bopomofoKeyboard) {
        // Add answer title
        const answerTitle = document.createElement("h4");
        answerTitle.textContent = "\u56DE\u7B54";
        questionDiv.appendChild(answerTitle);
        const inputElement = document.createElement("div");
        inputElement.id = `sor-input-${question.id}`;
        inputElement.contentEditable = true;
        inputElement.className = question.inputType === "textarea" ? "editable-div" : "editable-input";
        inputElement.setAttribute("data-placeholder", "\u8ACB\u8F38\u5165\u6587\u5B57\u6216\u5C08\u5229\u6CE8\u97F3...");
        // Apply onlyCustomKeyboard setting
        if (question.onlyCustomKeyboard) {
            inputElement.setAttribute("data-placeholder", "\u8ACB\u900F\u904E\u5C08\u5229\u6CE8\u97F3\u56DE\u7B54...");
            inputElement.addEventListener("keydown", (e)=>{
                if (e.key !== "Tab") e.preventDefault();
            });
        }
        // Add focus event to set current input element
        inputElement.addEventListener("focus", ()=>(0, $e039ef6aaef3acdd$export$88f7b48baf778b50)(inputElement));
        questionDiv.appendChild(inputElement);
        const hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = question.id;
        hiddenInput.id = `hidden-${question.id}`;
        questionDiv.appendChild(hiddenInput);
    } else {
        // Add answer title
        const answerTitle = document.createElement("h4");
        answerTitle.textContent = "\u56DE\u7B54";
        questionDiv.appendChild(answerTitle);
        // 如果沒有設置 bopomofoKeyboard，使用常規輸入
        const input = question.inputType === "textarea" ? document.createElement("textarea") : document.createElement("input");
        input.type = question.inputType === "text" ? "text" : question.inputType;
        input.id = `question-${question.id}`;
        input.name = question.id; // Add name attribute
        questionDiv.appendChild(input);
    }
    return questionDiv;
}
function $7fa80a46c1067125$var$createSubmitButton() {
    const submitButton = document.createElement("button");
    submitButton.textContent = "\u63D0\u4EA4\u7B54\u6848";
    submitButton.className = "submit-button";
    submitButton.type = "submit"; // 明確設置為 submit 類型
    return submitButton;
}
function $7fa80a46c1067125$var$createTestButton() {
    const testButton = document.createElement("button");
    testButton.textContent = "Test: Prefill Answers";
    testButton.className = "test-button";
    testButton.type = "button"; // 設置按鈕類型為 'button'
    testButton.addEventListener("click", $7fa80a46c1067125$var$prefillAnswers);
    return testButton;
}
function $7fa80a46c1067125$var$prefillAnswers() {
    // Prefill common questions
    const commonQuestions = document.querySelectorAll(".common-question");
    commonQuestions.forEach((questionDiv, index)=>{
        const input = questionDiv.querySelector('input[type="text"]');
        const radios = questionDiv.querySelectorAll('input[type="radio"]');
        if (input) input.value = `${index + 1}`;
        else if (radios.length > 0) radios[0].checked = true; // Select the first radio option
    });
    // Prefill main questions
    const mainQuestions = document.querySelectorAll(".question");
    mainQuestions.forEach((questionDiv, index)=>{
        const input = questionDiv.querySelector('input[type="text"], textarea');
        const editableDiv = questionDiv.querySelector("[contenteditable]");
        if (input) input.value = `${index + 1}`;
        else if (editableDiv) editableDiv.textContent = `${index + 1}`;
    });
    console.log("All answers have been prefilled for testing.");
}
document.addEventListener("DOMContentLoaded", ()=>{
    const container = document.querySelector(".container");
    // Create and append test header
    const testHeader = $7fa80a46c1067125$var$createTestHeader((0, $1aff465550c1c1fe$export$2e2bcd8739ae039).settings);
    container.appendChild(testHeader);
    // Create and append test content (now a form)
    const testForm = $7fa80a46c1067125$var$createTestContent((0, $1aff465550c1c1fe$export$2e2bcd8739ae039));
    container.appendChild(testForm);
    // Create and append end description
    const endDescription = $7fa80a46c1067125$var$createEndDescription((0, $1aff465550c1c1fe$export$2e2bcd8739ae039).settings);
    container.appendChild(endDescription);
    // Add submit button to the form
    const submitButton = $7fa80a46c1067125$var$createSubmitButton();
    testForm.appendChild(submitButton);
    // Add test button for prefilling answers
    const testButton = $7fa80a46c1067125$var$createTestButton();
    container.appendChild(testButton);
    // Create and append the fixed SOR keyboard
    const keyboardContainer = document.createElement("div");
    keyboardContainer.id = "fixed-sor-keyboard";
    (0, $e039ef6aaef3acdd$export$9852ddb15aeb7ca3)(keyboardContainer);
    container.appendChild(keyboardContainer);
    // 創建固定位置的容器來放置鍵盤和切換按鈕
    const fixedKeyboardContainer = document.createElement("div");
    fixedKeyboardContainer.id = "fixed-keyboard-container";
    (0, $e039ef6aaef3acdd$export$9852ddb15aeb7ca3)(fixedKeyboardContainer);
    document.body.appendChild(fixedKeyboardContainer);
    // Add form submit event listener
    testForm.addEventListener("submit", function(event) {
        event.preventDefault();
        if ($7fa80a46c1067125$var$validateForm(this)) {
            console.log("Form is valid, submitting...");
            this.submit();
        } else console.log("Form validation failed");
    });
});
function $7fa80a46c1067125$var$validateForm(form) {
    const unansweredQuestions = [];
    // Validate all inputs
    form.querySelectorAll('input[type="text"], input[type="radio"], textarea, [contenteditable]').forEach((element)=>{
        let value;
        if (element.type === "radio") {
            const name = element.getAttribute("name");
            value = form.querySelector(`input[name="${name}"]:checked`) ? "checked" : "";
        } else if (element.hasAttribute("contenteditable")) value = $7fa80a46c1067125$var$convertEditableDivContent(element);
        else value = element.value.trim();
        if (!value) {
            const questionTitle = element.closest(".question, .common-question").querySelector("h3").textContent;
            unansweredQuestions.push(questionTitle);
        }
    });
    if (unansweredQuestions.length > 0) {
        alert(`\u{8ACB}\u{56DE}\u{7B54}\u{4EE5}\u{4E0B}\u{554F}\u{984C}\u{FF1A}
${unansweredQuestions.join("\n")}`);
        return false;
    }
    // Update hidden inputs for contenteditable elements
    form.querySelectorAll("[contenteditable]").forEach((element)=>{
        const hiddenInput = document.getElementById(`hidden-${element.id.split("-").pop()}`);
        if (hiddenInput) {
            hiddenInput.value = $7fa80a46c1067125$var$convertEditableDivContent(element);
            console.log(`Updated hidden input ${hiddenInput.id} with value: ${hiddenInput.value}`);
        } else console.warn(`Hidden input not found for ${element.id}`);
    });
    return true;
}
function $7fa80a46c1067125$var$convertEditableDivContent(editableDiv) {
    let result = [];
    let hasImage = false;
    editableDiv.childNodes.forEach((node)=>{
        if (node.nodeType === Node.TEXT_NODE) result.push(node.textContent.trim());
        else if (node.nodeName === "IMG") {
            hasImage = true;
            result.push(node.dataset.value || node.alt);
        } else if (node.nodeName === "BR") result.push("\n");
    });
    // If there are multiple images, join them with periods
    if (hasImage) return result.filter((item)=>item !== "").join(".");
    else return result.join("").trim();
}

})();
//# sourceMappingURL=index.20446334.js.map
